module.exports = __webpack_public_path__ + "static/media/zdj-plg1.1bd1ba1b.JPG";